import Vue from 'vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

const OpenIndicator = Vue.component('open-indicator', {
    template: `
    <svg width="9"
        height="8"
        viewBox="0 0 9 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.70521 6.58952C5.31593 7.23162 4.38425 7.23162 3.99497 6.58952L0.920547 1.51843C0.516512 0.851991 0.996323 0 1.77567 0L7.92451 0C8.70386 0 9.18366 0.851993 8.77963 1.51843L5.70521 6.58952Z"
            fill="#979797" />
    </svg> 
    `,
});

vSelect.props.components.default = () => ({
    OpenIndicator,
});

Vue.component('dropdown-with-search', vSelect);
